import React, { FC } from 'react';
import styled from 'styled-components';
import { BackgroundStyle, BackgroundType } from './styles';

const BoxContainer = styled.div`
  width: 100%;
  height: 0;
  overflow: hidden;
  position: relative;
  background-size: cover;
  background-position: 50%;
  display: flex;
  padding-top: ${(props: any) => (props.ratio || 1) * 100}%;
  ${BackgroundStyle}
`;

const BoxWrapper = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  position: absolute;
`;

export const Box: FC<{ ratio: number } & BackgroundType> = ({
  children,
  ...props
}) => (
  <BoxContainer {...props}>
    <BoxWrapper>{children}</BoxWrapper>
  </BoxContainer>
);
